import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { camelToKebabCase } from 'utils/camelToKebabCase';

import Button from 'components/Buttons';
import Card from 'components/Card';
import Title from 'components/Title';
import { useAuthenticatedContext } from 'hooks/useAuthenticated';
import { CATEGORY_TYPE } from 'models/documents.model';

import * as Styled from './NewCertTypePage.styles';

const NewCertTypePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { currentUser } = useAuthenticatedContext();

  const navigateToCertificateType = (category: CATEGORY_TYPE) => () => {
    navigate(`/home/new-certificate/${camelToKebabCase(category)}`);
  };

  return (
    <Card backButtonLink="/home/certificates" padding="large">
      <Title>{t('certificate.newCertificate')}</Title>
      {t('certificate.chooseCertificateType')}
      <Styled.ButtonsContainer>
        {currentUser?.category && (
          <Button $login $block onClick={navigateToCertificateType(currentUser.category)}>
            {t(`certificate.${currentUser.category}`)}
          </Button>
        )}
        <Button $login $block onClick={navigateToCertificateType(CATEGORY_TYPE.CERTIFICATE)}>
          {t('certificate.other')}
        </Button>
      </Styled.ButtonsContainer>
    </Card>
  );
};

export default NewCertTypePage;
